module.exports = __webpack_public_path__ + "img/highShotText3.e6a25c5c.png";